import ScoringRequestModal from './scoringRequestModal';

export default ScoringRequestModal;
